const V1_BASE_URL = 'v1/billing';

export const TRANSACTION_FEE_TO_PAY = `${V1_BASE_URL}/transaction-fee-to-pay`;
export const TRANSACTION_FEE_PAID = `${V1_BASE_URL}/transaction-fee-paid`;
export const PAYMENTS_HISTORY = `${V1_BASE_URL}/payments-history`;
export const TRANSACTION_FEES_LIST = `${V1_BASE_URL}/transaction-fees`;
export const GET_OR_CREATE_PAY_ORDER = `${V1_BASE_URL}/transaction-fees/pay-order`;
